// extracted by mini-css-extract-plugin
module.exports = {"icon":"manaFont_icon__dgrH_"};